import { startWith, shareReplay } from "rxjs"
import { setModal$ } from "./command"

export const modalChanged$ = setModal$

export const modalChangedStartAndShare$ = modalChanged$.pipe(
  startWith(undefined),
  shareReplay(1)
)
